import React, { useMemo } from "react";
import { Clock3, DollarSign, Users } from "lucide-react";
import { formatCurrency } from "../../pages/Projects/projects.helpers";
import { summarizeProjectResources } from "./projectResources";

const formatNumber = (value) =>
  Number(value || 0).toLocaleString("es-AR", { maximumFractionDigits: 2 });

const deviationLabel = (value, suffix = "") => {
  const number = Number(value || 0);
  const sign = number > 0 ? "+" : "";
  return `${sign}${formatNumber(number)}${suffix}`;
};

function ProjectResourcesSummary({ tasks = [], assigneeOptions = [] }) {
  const summary = useMemo(
    () => summarizeProjectResources(tasks, assigneeOptions),
    [assigneeOptions, tasks],
  );

  return (
    <section className="projects-card project-resources-section">
      <div className="projects-card-header projects-detail-section-header">
        <div>
          <h2>Recursos del plan</h2>
          <p>Comparación entre lo planificado y lo utilizado en las tareas</p>
        </div>
      </div>

      {tasks.length === 0 ? (
        <p className="projects-empty">Agregá tareas para planificar horas, costos y responsables.</p>
      ) : (
        <>
          <div className="project-resource-totals">
            <article>
              <Clock3 size={20} />
              <div><span>Horas</span><strong>{summary.actualHoursCount ? formatNumber(summary.actualHours) : "Sin datos reales"} / {formatNumber(summary.plannedHours)} h previstas</strong></div>
              <small className={summary.hoursDeviation > 0 ? "is-over" : ""}>{summary.hoursComplete ? `Desvío: ${deviationLabel(summary.hoursDeviation, " h")}` : `${summary.actualHoursCount} de ${tasks.length} tarea(s) con horas reales`}</small>
            </article>
            <article>
              <DollarSign size={20} />
              <div><span>Costos de tareas</span><strong>{summary.actualCostCount ? `$ ${formatCurrency(summary.actualCost)}` : "Sin datos reales"} / $ {formatCurrency(summary.plannedCost)} previstos</strong></div>
              <small className={summary.costDeviation > 0 ? "is-over" : ""}>{summary.costsComplete ? `Desvío: $ ${deviationLabel(summary.costDeviation)}` : `${summary.actualCostCount} de ${tasks.length} tarea(s) con costo real`}</small>
            </article>
            <article>
              <Users size={20} />
              <div><span>Responsables</span><strong>{summary.people.filter((person) => person.id !== "unassigned").length}</strong></div>
              <small>{summary.people.find((person) => person.id === "unassigned")?.taskCount || 0} tarea(s) sin asignar</small>
            </article>
          </div>

          <div className="project-resource-people" aria-label="Asignación de trabajo por responsable">
            {summary.people.map((person) => (
              <article key={person.id}>
                <div><strong>{person.label}</strong><span>{person.taskCount} tarea(s)</span></div>
                <div><span>Avance promedio</span><strong>{formatNumber(person.averageProgress)} %</strong></div>
                <div><span>Horas reales / previstas</span><strong>{formatNumber(person.actualHours)} / {formatNumber(person.plannedHours)} h</strong></div>
              </article>
            ))}
          </div>
        </>
      )}
    </section>
  );
}

export default ProjectResourcesSummary;
